import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/",
    redirect: '/index'
  },
  {
    path: "/index",
    name: "index",
    component: () => import("@/views/index/index.vue"),
  },
  {
    path: "/mobileIndex",
    name: "mobileIndex",
    component: () => import("@/views/index/mobileIndex.vue"),
  },
  {
    path: "/introduce",
    name: "introduce",
    component: () => import("@/views/introduce/index.vue"),
  },
  {
    path: "/mobileIntroduce",
    name: "mobileIntroduce",
    component: () => import("@/views/introduce/mobileIndex.vue"),
  },
  {
    path: "/businessScope",
    name: "businessScope",
    component: () => import("@/views/businessScope/index.vue"),
  },
  {
    path: "/mobileBusinessScope",
    name: "mobileBusinessScope",
    component: () => import("@/views/businessScope/mobileIndex.vue"),
  },
  {
    path: "/post",
    name: "post",
    component: () => import("@/views/post/index.vue"),
  },
  {
    path: "/mobilePost",
    name: "mobilePost",
    component: () => import("@/views/post/mobileIndex.vue"),
  },
  {
    path: "/case",
    name: "case",
    component: () => import("@/views/case/index.vue"),
  },
  {
    path: "/mobileCase",
    name: "mobileCase",
    component: () => import("@/views/case/mobileIndex.vue"),
  },
  {
    path: "/concat",
    name: "concat",
    component: () => import("@/views/concat/index.vue"),
  },
  {
    path: "/mobileConcat",
    name: "mobileConcat",
    component: () => import("@/views/concat/mobileIndex.vue"),
  },
  {
    path: "/3d",
    name: "3d",
    component: () => import("@/views/3D/index.vue"),
  },
  {
    path: "/mobile3d",
    name: "mobile3d",
    component: () => import("@/views/3D/mobileIndex.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
})
export default router;